import {
  AfterContentChecked,
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  Renderer2
} from '@angular/core';
import { IonContent } from '@ionic/angular';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { ContextService } from '../../core/services/core/context.service';

@Directive({
  selector: '[animationProductResume]'
})
export class AnimationProductResumeDirective
  implements AfterViewInit, AfterContentChecked {
  @Input() animationContent;
  private parent: HTMLElement;
  private fixedWrapper: HTMLElement;
  private alert: Element;
  private toolbar: Element;
  private content: Element;
  private segmentToolbar: Element;
  private contentPosition = '';

  private readonly MARGIN_BETWEEN_WRAPPER_AND_CONTENT = 40;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private ctx: ContextService,
  ) {}

  ngAfterContentChecked() {
   if (this.parent) {
      this.updateContentPositionBasedOnFixedWrapper();
      this.updateFixedWrapperWidth();
    }
  }

  ngAfterViewInit() {
    if (!this.ctx.isApp) {
      this.setInitialValues();
      const hasScrolledDown$ = (this
        .animationContent as IonContent).ionScroll.pipe(
        map(ev => ev.detail.scrollTop > 0),
        distinctUntilChanged()
      );
      hasScrolledDown$.subscribe(hasScrolledDown => {
        this.showOrHideNode(hasScrolledDown);
      });
    }
  }

  private updateContentPositionBasedOnFixedWrapper() {
    const wrapperHeight = this.fixedWrapper.offsetHeight;
    this.contentPosition = `${wrapperHeight + this.MARGIN_BETWEEN_WRAPPER_AND_CONTENT}px`;
    this.renderer.setStyle(this.content, 'margin-top', this.contentPosition);
  }

  private updateFixedWrapperWidth() {
    this.getElements();
    if (this.shouldWrapperWidthBeNarrowed()) {
      this.renderer.setStyle(this.fixedWrapper, 'width', 'calc(100% - 17px)');
    } else {
      this.renderer.setStyle(this.fixedWrapper, 'width', '100%');
    }
  }

  private shouldWrapperWidthBeNarrowed() {
    return this.fixedWrapper && !this.ctx.isApp && (this.ctx.isTablet || this.ctx.isDesktop) && this.isScrollable();
  }

  private setInitialValues() {
    if (!this.ctx.isApp) {
      this.getElements();
      this.setContentPosition();
      this.setInitialStyle();
    }
  }

  private isScrollable() {
    const scrollArea = this.animationContent.el.querySelector('.scroll-area')
      .scrollHeight;
    const contentArea = this.animationContent.el.clientHeight;
    return (
      scrollArea - contentArea > 0
    );
  }

  private showOrHideNode(hasScrolledDown: boolean) {
    if (!this.isScrollable() && hasScrolledDown) { return; }
    this.setInitialValues();
    const contentRelativePosition = `${this.fixedWrapper.offsetHeight +
      this.MARGIN_BETWEEN_WRAPPER_AND_CONTENT}px`;
    if (this.toolbar) {
      this.renderer.setStyle(
        this.toolbar,
        'display',
        hasScrolledDown ? 'none' : 'block'
      );
      this.renderer.setStyle(
        this.content,
        'margin-top',
        contentRelativePosition
      );
      this.renderer.setStyle(
        this.segmentToolbar,
        'margin-top',
        hasScrolledDown ? '20px' : '40px'
      );
      this.renderer.setStyle(
        this.content,
        'min-height',
        hasScrolledDown ? 'calc(100vh - 80px - 60px - 150px)' : 'none'
      );
    }
    if (this.alert) {
      this.renderer.setStyle(
        this.alert,
        'display',
        hasScrolledDown ? 'none' : 'block'
      );
      this.renderer.setStyle(
        this.content,
        'margin-top',
        contentRelativePosition
      );
      this.renderer.setStyle(
        this.content,
        'min-height',
        hasScrolledDown ? 'calc(100vh - 80px - 60px - 150px)' : 'none'
      );
    }
  }

  private setInitialStyle() {
    this.renderer.setStyle(this.content, 'margin-top', this.contentPosition);
  }

  private setContentPosition() {
    const wrapperHeight = this.fixedWrapper.offsetHeight;
    this.contentPosition = `${wrapperHeight + this.MARGIN_BETWEEN_WRAPPER_AND_CONTENT}px`;
  }

  private getElements() {
    this.parent = this.el.nativeElement;
    this.toolbar = this.parent
      .getElementsByTagName('mapfre-top-navigation')
      .item(0);
    this.alert = this.parent.getElementsByClassName('alerts-container').item(0);
    this.content = this.parent.getElementsByClassName('bg-color-white').item(0);
    this.segmentToolbar = this.parent.getElementsByClassName('segment').item(0)
      ? this.parent.getElementsByClassName('segment').item(0).children.item(0)
      : null;
    this.fixedWrapper = this.parent?.children?.item(0) as HTMLElement;
  }
}
